import styled from "@emotion/styled";

const NavItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: flex-start;
  gap: 16px;
  padding: 0 20px 16px;
`;

export default NavItemsContainer;
